import { KamigameCommentApiClient } from '@/comment-api-client/KamigameCommentAPIClient';

export function createCommentApiClient(): KamigameCommentApiClient {
  return new KamigameCommentApiClient({
    baseUri: `${COMMENT_API_URL_BASE}`,
  });
}
